import {connect} from "react-redux";

const React = require('react');

class UserHomePage extends React.Component {
    render() {

        const username = this.props.user.firstName + " " + this.props.user.lastName;
        const email = this.props.user.email;
        const department = this.props.user.department ? this.props.user.department.name : null;
        const canApprove = this.props.user.isInApprovalFlow;
        const canAddPapers = department !== null;
        const companyName = this.props.user.companyName;

        return (
            <div style={{textAlign: 'center'}}>
                <div>
                    <h1>Bine ati venit!</h1>
                </div>

                <div style={{marginTop: '50px'}}>
                    <span style={{display: 'inline'}}>{"Institutie: "}</span>
                    <strong style={{display: 'inline'}}>{companyName}</strong>
                </div>

                <div style={{marginTop: '10px'}}>
                    <span style={{display: 'inline'}}>{"Nume: "}</span>
                    <strong style={{display: 'inline'}}>{username}</strong>
                </div>

                <div style={{marginTop: '10px'}}>
                    <span style={{display: 'inline'}}>{"Email: "}</span>
                    <strong style={{display: 'inline'}}>{email}</strong>
                </div>

                {department && <div style={{marginTop: '10px'}}>
                    <span style={{display: 'inline'}}>{"Compartiment: "}</span>
                    <strong style={{display: 'inline'}}>{department}</strong>
                </div>}

                <div style={{marginTop: '10px'}}>
                    <span style={{display: 'inline'}}>{"Aveti drept de aprobare?: "}</span>
                    <strong style={{display: 'inline'}}>{canApprove ? "DA" : "NU"}</strong>
                </div>

                <div style={{marginTop: '10px'}}>
                    <span style={{display: 'inline'}}>{"Puteti adauga referate?: "}</span>
                    <strong style={{display: 'inline'}}>{canAddPapers ? "DA" : "NU"}</strong>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        user: state.login.user,
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(UserHomePage)
